import { SuperInputBase } from "@components:SuperInput/SuperInput.Base";
import { SuperInputProps } from "@components:SuperInput/types";
import { Switch, SwitchProps } from "@mui/material";

export type SuperInputSwitchProps = SuperInputProps &
  SwitchProps & {
    width?: string;
  };

export const SuperInputSwitch = ({
  label,
  helperText,
  explainText,
  sx,
  width,
  errorText,
  required,
  autoHeight,
  ...props
}: SuperInputSwitchProps) => {
  return (
    <SuperInputBase
      autoHeight={autoHeight}
      label={label}
      helperText={helperText}
      explainText={explainText}
      errorText={errorText}
      required={required}
      sx={sx}
    >
      <Switch
        {...props}
        className={"SuperInput__Switch"}
        sx={{
          width: width ?? undefined,
        }}
      />
    </SuperInputBase>
  );
};
